import { render, staticRenderFns } from "./GoToV2Banner.vue?vue&type=template&id=acda89e6&scoped=true&"
import script from "./GoToV2Banner.vue?vue&type=script&lang=js&"
export * from "./GoToV2Banner.vue?vue&type=script&lang=js&"
import style0 from "./GoToV2Banner.vue?vue&type=style&index=0&id=acda89e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acda89e6",
  null
  
)

export default component.exports